module.exports = __webpack_public_path__ + "img/142ne.685065e9.svg";